export default [
  {
    path: "/pei/at",
    name: "at-tabs",
    component: () => import("@/views/At.vue"),
    meta: { IsParent: true }
  },
  {
    path: "/pei/At/search/:academicYearId?/:studentSieId?",
    name: "worktraysearch",
    component: () => import("@/components/pei/At/Main")
  },
  {
    path: "/pei/At/questionary/equipments/:peiId",
    name: "QuestionaryEquipmentsView",
    component: () =>
      import("@/views/pei/atEquipment/QuestionaryEquipmentsView.vue")
  },
  {
    path: "/at/evaluationdiscussion/:referralId?",
    name: "EvaluationDiscussionAT",
    component: () =>
      import("@/components/at/evaluationdiscussionAT/EvaluationDiscussionAT")
  },
  {
    path: "/at/referralatdiscussionschool/:referralId?",
    name: "ReferralATDiscussionSchool",
    component: () =>
      import(
        "@/components/at/referralATDiscussionSchool/ReferralATDiscussionSchool"
      )
  }
];
